/**
 * feAI – Frontend
 * src/lib/authApi.ts
 *
 * Typed wrappers around the api-core authentication endpoints.
 */

import { apiClient } from './apiClient';
import type {
  ApiResponse,
  LoginPayload,
  LoginResponseData,
  SelectProfilePayload,
  SsoLoginPayload,
  LoginResponseOk,
  ForgotPasswordResponseData,
  VerifyOtpResponseData,
  ResetPasswordResponseData,
} from '../types/auth';

/** POST /api/v1/core/auth/login */
export async function apiLogin(payload: LoginPayload): Promise<LoginResponseData> {
  const { data } = await apiClient.post<ApiResponse<LoginResponseData>>(
    '/api/v1/core/auth/login',
    payload
  );
  return data.data;
}

/** POST /api/v1/core/auth/select-profile */
export async function apiSelectProfile(
  payload: SelectProfilePayload
): Promise<LoginResponseOk> {
  const { data } = await apiClient.post<ApiResponse<LoginResponseOk>>(
    '/api/v1/core/auth/select-profile',
    payload
  );
  return data.data;
}

/** POST /api/v1/core/auth/forgot-password */
export async function apiForgotPassword(
  identificativo: string
): Promise<ForgotPasswordResponseData> {
  const { data } = await apiClient.post<ApiResponse<ForgotPasswordResponseData>>(
    '/api/v1/core/auth/forgot-password',
    { identificativo }
  );
  return data.data;
}

/** POST /api/v1/core/auth/verify-otp */
export async function apiVerifyOtp(otp: string): Promise<VerifyOtpResponseData> {
  const { data } = await apiClient.post<ApiResponse<VerifyOtpResponseData>>(
    '/api/v1/core/auth/verify-otp',
    { otp }
  );
  return data.data;
}

/** POST /api/v1/core/auth/reset-password */
export async function apiResetPassword(
  token: string,
  channel: 'email' | 'sms',
  newPassword: string
): Promise<ResetPasswordResponseData> {
  const { data } = await apiClient.post<ApiResponse<ResetPasswordResponseData>>(
    '/api/v1/core/auth/reset-password',
    { token, channel, new_password: newPassword }
  );
  return data.data;
}

/** POST /api/v1/core/auth/sso-login */
export async function apiSsoLogin(payload: SsoLoginPayload): Promise<LoginResponseOk> {
  const { data } = await apiClient.post<ApiResponse<LoginResponseOk>>(
    '/api/v1/core/auth/sso-login',
    payload
  );
  return data.data;
}
